import { PromoCodesForm } from 'components/promoCodes/PromoCodesForm/PromoCodesForm'
import { useParams } from 'react-router-dom'

export const PromoCodesEdit: React.FC = () => {
  const { sellerId, id } = useParams<{ sellerId?: string; id: string }>()
  return <PromoCodesForm mode='edit' sellerId={sellerId} promoCodeId={id} />
}
